import { isIranMarket } from '@parsina/framework/ui/lib/brand';
import { SECTIONS } from '@parsina/framework/clinical/src/screens/Settings/Settings.shared';

// ─────────────────────────────────────────────────────────────────────────────
// The settings sections this deployment offers. The registry is the kit's
// (Settings.shared.js SECTIONS); which of them a market has is the panel's call.
//
// «نسخه» is Iranian through and through — what a visit bills as is the RVU3 visit
// code, read against the doctor's degree in the Iranian medical council's
// register — so outside the Iranian market (`market: 'intl'`,
// docs/rebranding/CONTRACT.md) the tab is not offered, and an address naming it
// lands on the default section like any unknown one. In the Iranian market, and
// with no brand at all, this is SECTIONS itself.
//
// APP_SECTIONS are sections this panel renders that the kit's registry does not
// carry yet — the kit-lag rule, as for the app-local string tables. Each names the
// section it follows and the SURFACES that have a render for it, so a section is
// never offered where nothing would draw it. A call without a surface is the kit's
// list alone, as it always was. «نوبت‌دهی آنلاین» (PM-0382) is desktop-only until
// the phone has its own screen for it. When the kit registry gains an id, the
// kit's entry wins and the line here is dead.
// ─────────────────────────────────────────────────────────────────────────────

const IRAN_ONLY_SECTIONS = ['prescription'];

export const APP_SECTIONS = Object.freeze([
  {
    id: 'booking',
    after: 'clinics',
    surfaces: ['desktop'],
    labelKey: 'settings.sections.booking.label',
    hintKey: 'settings.sections.booking.hint',
  },
]);

/** @param {'desktop'|'mobile'} [surface] — omitted: the kit's sections only. */
export function visibleSections(surface) {
  const base = isIranMarket() ? SECTIONS : SECTIONS.filter((s) => !IRAN_ONLY_SECTIONS.includes(s.id));
  if (!surface) return base;
  const out = [...base];
  for (const { after, surfaces, ...section } of APP_SECTIONS) {
    if (!surfaces.includes(surface) || out.some((s) => s.id === section.id)) continue;
    const at = out.findIndex((s) => s.id === after);
    out.splice(at < 0 ? out.length : at + 1, 0, section);
  }
  return out;
}

export const isVisibleSection = (id, surface) => visibleSections(surface).some((s) => s.id === id);
